export const ErrorCode = {
  INVALID_AUTO_RECORD: 1003,
};
